import styled from 'styled-components';
import appTheme from '../../../../themes/Theme';
import JSONPretty from 'react-json-pretty';
import XMLViewer from 'react-xml-viewer';
import Box from '@material-ui/core/Box';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

export const StyledTabs = styled(Tabs)`
  background-color: ${appTheme.tabPanelColor};
  & span.MuiTabs-indicator {
    background-color: rgb(37, 194, 160);
  }
`;

export const StyledTab = styled(Tab)`
  &.MuiTab-textColorPrimary {
    color: ${appTheme.textColor};
  }
  &.MuiTab-textColorPrimary.Mui-selected {
    color: rgb(37, 194, 160);
  }
`;

export const StyledBox = styled(Box)`
  && {
    padding: 0;
  }
`;
export const StyledCSVLinkContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(39, 40, 34);
  min-height: 60px;
  & a {
    color: rgb(37, 194, 160);
  }
`;

export const StyledJSONPretty = styled(JSONPretty)`
  & pre {
    margin-top: 0;
    padding: 16px 0px;
  }
`;

export const StyledXMLViewer = styled(XMLViewer)`
  background-color: rgb(39, 40, 34);
  font-family: monospace;
  padding: 16px 0px;
`;

export const FlexCenterContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const StyledLoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
`;

export const StyledResultContainer = styled.div`
  margin-top: 32px;
  overflow: auto;
`;

export const StyledInputLabel = styled(InputLabel)`
  color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  &.MuiFormLabel-root.Mui-focused{
    color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
  }
`;

export const StyledSelect = styled(Select)`
  color: ${(props) => (props.error ? '#f44336' : appTheme.textColor)};
  &.MuiInput-underline:hover:not(.Mui-disabled):before {
      border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
    } 
  && {
    ::before {
      border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
    }
    ::after {
      border-bottom-color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
    }
    > svg {
      color: ${(props) => (props.error ? '#f44336' : '#38c2a0')};
    }
  }
`;
